import React from "react";
import "./InfoReport.scss";
import Header from "../../Home/Header/Header";

const InfoReport = () => {
  return (
    <div>
      <Header otherPage={true} title="Info Report" />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <p style={{ margin: "0px" }}>Coming Soon...</p>
      </div>
    </div>
  );
};

export default InfoReport;
